<template>
  <div class="text-center">
    <v-dialog persistent v-if="visible" v-model="visible" width="400">
      <v-card class="not-margin pt-0 pr-0 pl-0">
        <v-toolbar dark color="primary">
          <div class="text-center">
            <v-icon>mdi-pencil</v-icon>
            {{ edit ? "Editar" : "Cadastrar" }} Ano Letivo
          </div>
        </v-toolbar>
        <div class="container dialog">
          <v-form ref="form">
            <v-row class="d-flex justify-center mt-7">
              <v-col cols="12">
                <v-text-field
                  v-model="content.ano"
                  label="Ano Letivo*"
                  maxlength="4"
                  outlined
                  dense
                  v-only-number
                  :rules="[(v) => $required(v), (v) => $max(v, 4), (v) => $min(v, 4)]"
                ></v-text-field>
              </v-col>
              <sca-date-picker
                :cols="12"
                label="Data de Início*"
                v-model="content.dataInicio"
                outlined
                dense
                :rules="[(v) => $required(v), dataInicioMenorQueFim]"
                :allowedDates="anoAtualOuMaior"
              ></sca-date-picker>
              <sca-date-picker
                :cols="12"
                label="Data de Término*"
                v-model="content.dataFim"
                outlined
                dense
                :allowedDates="anoAtualOuMaior"
                :rules="[(v) => $required(v), dataInicioMenorQueFim]"
              ></sca-date-picker>
            </v-row>
          </v-form>
          <div class="alert-message d-flex align-center mt-4">
            <v-icon color="warning" class="mr-2">mdi-alert-circle</v-icon>
            <span>Os campos marcados com asterisco(*) são obrigatórios</span>
          </div>
        </div>
        <sca-buttons
          @click="salvar()"
          @cancel="$emit('onClose')"
          :actionText="edit ? 'Editar' : 'Salvar'"
        ></sca-buttons>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { DialogProps } from '~/commons/classes/dialog-props';
import { AnoLetivo } from '~/commons/classes/ano-letivo';
import AnoLetivoService from '~/services/ano-letivo.service';

export default {
  props: new DialogProps(AnoLetivo),
  mixins: [AnoLetivoService],
  methods: {
    salvar() {
      const save = () => {
        return this.$swal({
          text: `Deseja ${this.edit ? "editar" : "cadastrar"} o registro?`,
          type: "warning",
          showCancelButton: true,
          confirmButtonText: `Confirmar`,
          cancelButtonText: `Cancelar`,
        }).then(() => {
          const anoLetivo = new AnoLetivo(this.content).format();
          return this.edit
            ? this.$editarAnoLetivo(anoLetivo, anoLetivo.id)
            : this.$cadastrarAnoLetivo(anoLetivo);
        });
      };
      if (this.$validarFormulario()) {
        save().then(({ data }) => {
          this.$notifySuccess(data.mensagem);
          this.$emit("onClose");
          this.$emit("onSave");
        });
      }
    },
    dataInicioMenorQueFim() {
      if (this.content.dataInicio && this.content.dataFim) {
        return this.content.dataInicio < this.content.dataFim || "A data de término deve ser após a data de início";
      }
      return true;
    },
    anoAtualOuMaior(date) {
      return parseInt(date.split('-')[0]) >= (new Date().getFullYear())
    }
  },
};
</script>